export const shopware6 = {
  clientId: "Zugangs-ID",
  clientSecret: "Sicherheitsschlüssel",
  clientIdHelp:
    'Die Zugangs-ID finden Sie im Shopware 6 Backend unter "Einstellungen > System > Integrationen".',
  clientSecretHelp:
    'Der Sicherheitsschlüssel kann im Shopware 6 Backend unter "Einstellungen > System > Integrationen" eingesehen werden. Bitte beachten Sie, dass der Sicherheitsschlüssel nur beim Erstellen der Integration angezeigt wird.'
};
